<template>
  <div>
    <div class="d-flex align-center justify-space-between">
      <div class="text-5 font-weight-medium">Amount</div>
      <div class="text-5 font-weight-light gray--text">
        ${{ amountUsd | currency }}
      </div>
    </div>
    <div class="mt-1">
      <v-text-field
        :value="value"
        type="number"
        outlined
        class="c-input input-vaults"
        hide-details
        @input="setAmount"
      ></v-text-field>
      <div class="d-flex justify-end mt-2">
        <div
          :class="[
            'btn-badge vault rounded-16 text-6 ml-1 py-2',
            { active: tick.selected },
          ]"
          v-for="tick in ticks"
          :key="tick.value"
          @click="updateTick(tick)"
        >
          {{ tick.text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BN from "bignumber.js";
export default {
  props: ["selectedAsset", "maxAmount", "value"],
  data: () => ({
    ticks: [
      {
        value: 0.25,
        text: "25%",
      },
      {
        value: 0.5,
        text: "50%",
      },
      {
        value: 0.75,
        text: "75%",
      },
      {
        value: 1,
        text: "Max",
      },
    ],
    rate: 1,
  }),
  computed: {
    ...mapGetters({
      getTokenPrice: "appConfig/getTokenPriceInUsd",
    }),
    amountUsd() {
      return (
        this.getTokenPrice(this.selectedAsset?.coin || "") * this.value || 0
      );
    },
  },
  methods: {
    updateTick(tick) {
      this.ticks = this.ticks.map(item => ({
        ...item,
        selected: item.value === tick.value,
      }));
      this.setAmount(
        new BN(tick.value)
          .multipliedBy(this.maxAmount)
          .toFixed(6, BN.ROUND_DOWN)
      );
    },
    setAmount(value) {
      if (new BN(value).gt(this.maxAmount || 0)) {
        value = new BN(this.maxAmount).toFixed(6, BN.ROUND_DOWN);
      }
      if (Number(value) === 0 || isNaN(Number(value))) {
        value = 0;
      }
      this.$emit("input", String(value));
    },
  },
  watch: {
    selectedAsset() {
      this.setAmount(0);
      this.updateTick({ value: 0 });
    },
    maxAmount(value) {
      if (new BN(value).gt(0) && new BN(this.value).eq(0)) {
        this.updateTick(this.ticks.slice(-1)[0]);
      }
    },
  },
};
</script>
